import { LIGHT_SHADOW } from "modules/storyblok/templates/AirHelpScore/styles";
import { Flex } from "@chakra-ui/react";
import type { TopThreeCardProps } from "./TopThreeCard.d";

const TopThreeCard = ({ children }: TopThreeCardProps) => (
  <Flex
    p={10}
    rounded="xl"
    borderColor="greyscale.400"
    bg="white"
    boxShadow={LIGHT_SHADOW}
    textAlign="center"
    flexDir="column"
    justifyContent="space-between"
  >
    {children}
  </Flex>
);

export default TopThreeCard;
